/**
 * Spots React's development-mode warnings among `console.error` lines. Only a
 * development React bundle (a local `vite` dev server) logs them, so the friction group
 * must not read them as error clicks: no deployed build ships development React
 * (app/buildMode.js). The diagnostics group still records them as `console.error`.
 */

/**
 * Openings of React dev-warning format strings (React 19 dropped the `Warning: `
 * prefix). Matched against the raw first argument, before scrubbing.
 */
const REACT_DEV_TEMPLATES = [
  /^%s a style property during rerender \(%s\) when a conflicting property is set/,
  /^Each child in a list should have a unique\b/,
  /^Encountered two children with the same key\b/,
  /^validateDOMNesting\b/,
  /^In HTML, %s cannot be a (?:child|descendant) of\b/,
  /^Cannot update a component \(`%s`\) while rendering a different component\b/,
  /^React does not recognize the `%s` prop on a DOM element\b/,
  /^A component is changing an? (?:un)?controlled input\b/,
  /^Invalid DOM property `%s`\. Did you mean `%s`\?/,
  /^Unknown event handler property `%s`\. It will be ignored\./,
];

/**
 * Whether a `console.error` call is a React development warning: its first argument
 * (`message`, the raw string) starts with `Warning: ` or opens with a known React
 * dev-warning template, and no argument is an Error (`args`: the call's arguments).
 * A React stack frame proves nothing: app effects run beneath React frames too.
 */
export function isReactDevWarning({ message, args = [] } = {}) {
  if (typeof message !== "string" || message === "") return false;
  if (args.some((a) => a instanceof Error)) return false;
  return message.startsWith("Warning: ") || REACT_DEV_TEMPLATES.some((re) => re.test(message));
}
